import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import api from './../../../../../Apis';
import Swal from "sweetalert2";
import { useCallback, useEffect, useState } from "react";
import LoadingButton from '@mui/lab/LoadingButton';
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import DialogSelectFanpages from "../../Fanpages/Posts/Components/DialogSelectFanpages";

export default function DialogKeywordMessage(props) {
    const { t } = useTranslation();
    const [state, setState] = useState({
        loading_button: false,
        fanpage_selected: [],
    })
    const {register, handleSubmit, reset, getValues, setValue} = useForm();
    const onSaveKeywordMessage = (data) => {
        if(state.fanpage_selected.length === 0 &&  props.index_edit_message == null) {
            Swal.fire({
                title: "Vui lòng chọn ít nhất 1 fanpage",
                icon: "warning",
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: "Đóng",
            })
            return;
        }
        setState({
            ...state,
            loading_button: true
        })
        props.onSaveKeywordMessage({
            ...data,
            fanpage_ids: state.fanpage_selected.map((item) => item.fanpage_id)
        });
    }
    const handleChangeFanpage = useCallback((fanpage_selected) => {
        setState((prevState) => ({
          ...prevState,
          fanpage_selected: fanpage_selected,
        }));
      }, []);

    useEffect(() => {
        if (props.index_edit_message != null && props.data_edit_message != null) {
            setValue('keyword', props.data_edit_message.keyword_comment);
            setValue('message', props.data_edit_message.message_inbox);
            setValue('block_code', props.data_edit_message.block.code);
        } else {
            reset();
        }
    }, [props.index_edit_message])

    return (
        <form onSubmit={handleSubmit(onSaveKeywordMessage)}>
            <Grid container spacing={2}>
                {
                    props.index_edit_message == null &&
                    <Grid item xs={12}>
                        {/* <FormGroup>
                            <FormControlLabel control={<Checkbox {...register('is_setting_together')} />} label={t("setting.label.settingsForAllFanpages")} />
                        </FormGroup> */}
                        <Box sx={{display: "flex", alignItems: "center", gap: "10px" }}>
                            <DialogSelectFanpages
                                listFanpages={props.list_fanpages}
                                fanpageSelected={state.fanpage_selected}
                                handleChangeFanpage={handleChangeFanpage}
                                buttonSize='small'
                                className="text-transform"
                            />
                            <Typography variant="body2" color={"error"}>
                                ({state.fanpage_selected.filter((item) => item.fanpage_id !== -1).length}) {t("post.selectedFanpage")}
                            </Typography>
                        </Box>
                    </Grid>
                }
                <Grid item xs={12}>
                    <FormControl className="w-100">
                        <FormLabel sx={{padding: '9px 0px'}} id="demo-radio-buttons-group-label">{t("setting.whenMessageContainsKeywords")}:</FormLabel>
                        <TextField
                            fullWidth id="outlined-basic"
                            size="small"
                            required
                            {...register('keyword')}
                            autoComplete="off"
                            placeholder={t("setting.label.keywordsSeparatedByComma")}
                            variant="outlined"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl className="w-100">
                        <FormLabel sx={{padding: '9px 0px'}} id="demo-radio-buttons-group-label">{t("setting.autoReplyMessageOptional")}: </FormLabel>
                        <textarea cols="30" {...register('message')} placeholder={t("setting.label.commentContent")} className="textarea" rows="5"></textarea>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormLabel sx={{padding: '9px 0px'}} id="demo-radio-buttons-group-label">
                            {/* Hoặc gửi Block, tạo block <Link to="/dashboard/chatbot"><span>tại đây</span></Link> */}
                            <Trans
                                i18nKey={"setting.orSendBlockCreateBlockHere"}
                                components={{ 1: <Link to="/dashboard/chatbot" />, span: <span /> }}
                            />
                        </FormLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={(props.index_edit_message != null && props.data_edit_message != null) ? props.data_edit_message.block.code : "null"}
                            {...register('block_code')}
                        >
                            <MenuItem value="null">{t("setting.selectAnyBlock")}</MenuItem>
                            {
                                Array.isArray(props.blocks) &&
                                props.blocks.map((value, key) => {
                                    return (
                                        <MenuItem value={value.code}>{value.name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                {/* <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox defaultChecked={props.data_edit_message != null ? props.data_edit_message.is_inbox : true} {...register('is_inbox')} />} label="Chỉ nhắn tin 1 lần/khách" />
                    </FormGroup>
                </Grid> */}
                <Grid item xs={12}>
                    {/* Thuật ngữ viết tắt nội dung tin nhắn:<br></br>
                    <b>{"{full_name}"}</b>: Tên khách hàng<br></br>
                    <b>{"{page_name}"}</b>: Tên page<br></br> */}
                     <Trans
                        i18nKey={"setting.messageAbbreviationTerms"}
                        values={{ full_name: "{full_name}", page_name: "{page_name}" }}
                        components={{
                            b: <b></b>
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton loading={state.loading_button} type="submit" startIcon={<SaveOutlinedIcon/>} variant="contained" color="primary">
                        {t("common.save")}
                    </LoadingButton>
                </Grid>
            </Grid>
        </form>
    )
}